export const PRODUCTS_TABS = ['sourcing', 'archived'] as const;

export type ProductsTab = (typeof PRODUCTS_TABS)[number];
